import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})
export class StudentService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,
                public fileUploadService: UploadService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.STUDENTS(), data);
    }

    getByStage(id, data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.STUDENTS_BY_STAGE(id), data);
    }

    getUnAssignedStudents(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNASSIGNED_STUDENTS(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.STUDENTS_COUNT());
    }

    admissionCount(): Observable<any> {
        return this.getRequest(AppUrl.STUDENTS_ADMISSION_COUNT());
    }

    inProgressCount(): Observable<any> {
        return this.getRequest(AppUrl.STUDENTS_IN_PROGRESS_COUNT());
    }

    getNotConnectedCount(): Observable<any> {
        return this.getRequest(AppUrl.STUDENTS_NOT_CONNECTED_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.STUDENTS(id));
    }

    detailByCounsellor(id): Observable<any> {
        return this.getRequest(AppUrl.STUDENTS_DETAILS_BY_COUNSELLOR(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.STUDENTS(), data);
    }

    studentRegister(data): Observable<any> {
        return this.postRequest(AppUrl.STUDENTS_REGISTER(), data);
    }

    studentBulkRegister(data): Observable<any> {
        return this.postRequest(AppUrl.STUDENTS_BULK_REGISTER(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.STUDENTS(id), data);
    }

    updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.STUDENT_PASSWORD(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.STUDENT_STATUS(id), data);
    }

    assignStudent(data): Observable<any> {
        return this.postRequest(AppUrl.ASSIGN_STUDENTS(), data);
    }

    fileUpload(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
    }

    studentBulkUpload(data): Observable<any> {
        return this.postRequest(AppUrl.STUDENTS_BULK_UPLOAD(), data);
    }

    getStudentReceiptUrl(id, data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.STUDENTS_RECEIPT_URL(id), data);
    }
}
